import moment from "jalali-moment"

export const useTokenCookie = defineComposable("token-cookie", () => {
	const tokenValue = useCookie("token", {
		sameSite: "strict",
		priority: "high",
		// This is not the token expiresation date itself, but a way to make a
		// Persistent data storage that could be shared on first request.
		expires: moment().add("years", 1).toDate(),
	})

	function setCookie(token: string) {
		tokenValue.value = token
	}

	function getCookie() {
		refreshCookie("token")
		return tokenValue.value
	}

	function clearCookie() {
		tokenValue.value = null
	}

	return {
		clearCookie,
		setCookie,
		getCookie,
	}
})
